export default __webpack_public_path__ + "static/media/Bindings of Conflagrant Flame.bd108eca.jpg";